//Constants for the operationStates
export const operationStates = {
  pendiente: 1,
  venta_n: 2,
  sena: 3,
  venta_b: 4,
  anulada: 5,
  finalizado: 6,
};
